import React from 'react'
import { FiBarChart } from 'react-icons/fi'

export const Reports = () => {
    return (
        <div className='row'>
            <div className='col-12'>
                <h1 className="h3 mb-3 fw-bold">
                    Reportes
                </h1>
            </div>
            {/* Contenido del modulo */}
            <div className='col-12 '>
                <div className="alert alert-warning" role="alert">
                    Esta en construccion
                </div>
            </div>
        </div>
    )
}
